import React, { Component } from 'react';
import LandingContact from './landingpages/LandingContact';
import { Grid, Modal, Backdrop, Fade } from '@mui/material';
import axios from 'axios';
import './style/App.css';

class Feedback extends Component {
  constructor(props) {
    super(props)
    this.state = {
      feedbackParams: {},
      feedbacksGivenCount: false,
      numberFeedbacksGiven: 0,
      open: true,
      textFields: {
        showName: true,
        showCompany: false,
        showEmail: true,
        showComment: true,
        commentTitle: 'Leave feedback here',
        formSubmitted: 'Your feedback was successfully submitted. Feel free to reach out to us any time.'
      }
    }
    this.feedbackScore = this.feedbackScore.bind(this);
    this.landingForm = this.landingForm.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.renderScore = this.renderScore.bind(this);
  }

  handleClose() {
    this.setState({
      open: false
    })
  }

  renderScore(score) {
    return(
      <span>of {score}</span>
    )
  }

  feedbackScore(score) {
    if (score > 8) {
      return null;
    } else if (score < 6) {
      // console.log('feedbackScore() is 1, 2, 3, 4, or 5: ', score);
      return (
        <p>We believe that feedback from partners like you is vital to improving how we deliver our service. As a result, when we receive a score of {score} out of 10, we take it seriously. We'd like to be better, just let us know how we can do that.</p>
      )
    } else {
      // console.log('feedbackScore() is 6, 7, or 8: ', score);
      return (
        <p>We believe that feedback from partners like you is vital to improving how we deliver our service. You gave us a score of {score} out of 10 and we'd like to do better - just tell us how.</p>
      )
    }
  }

//can leave name, company, comment blank - let state set email and srnumber, generate boolean for confirmed
  landingForm(name, company, email, comment) {
    let feedbackResult = {};
    feedbackResult.name = name; //filled out in web form
    feedbackResult.company = company; //filled out in web form
    feedbackResult.email = email; //email address that was filled out in the web form
    feedbackResult.comment = comment; //comment that was filled out in the web form
    feedbackResult.emailId = this.state.feedbackParams.email; //this is the email address that received the feedback/emailed url
    feedbackResult.srnumber = this.state.feedbackParams.srnumber//this is the service request / ticket number associated with the feedback
    this.props.submitFeedbackContact(feedbackResult)
      .catch((error) => {
        console.log('error in feedbackResult: ', error);
      });
  }

  confirm(myState) {
    console.log("*** entering confirm() in /feedback ***")
    console.log('1. check myState: ', myState);
    console.log('1. check this.state.currentId: ', this.state.currentId);
    // let feedbackParams = this.props.props.match.params;
    let confirmData = {}
    confirmData.email = myState.feedbackParams.email;
    confirmData.currentId = this.state.currentId;
    console.log('2. check data added to confirmData: ', confirmData);
    axios.post('/Feedback/confirmFeedback', {
      data: confirmData
    }).then((response) => {
      console.log('3. SUCCESS - confirm db response (/feedback): ', response.data);
      this.setState({
        open: false
      })
    }).catch((err) => {
      console.log('3. ERR - confirm db response (/feedback): ', err);
    })
  }

  componentDidMount() {
    console.log('*** entering compDidMnt (Feedback.js) ***');
    const nv = navigator;
    const userInfo = {};
    userInfo.language = nv.language;
    userInfo.devicePlatform = nv.platform;
    userInfo.browser = nv.userAgent
    userInfo.connection = nv.connection;
    // console.log('userInfo: ', userInfo);
    let feedbackParams = this.props.params || {};
    // console.log('1. CmptDidMnt, pre-.post, feedbackParams (Feedback.js): ', feedbackParams);
    if (feedbackParams.email !== '' && feedbackParams.srnumber !== '' && feedbackParams.score !== '') {
      axios.post('/Feedback', {
        data: feedbackParams,
        params: {
          email: feedbackParams.email,
          srnumber: feedbackParams.srnumber,
          userInfo: userInfo,
          score: feedbackParams.score
        }
      }).then((response) => {
        //response.data includes CW data as well as Feedback data
        console.log('2. DB+CW Response in compDidMnt (Feedback.js): ', response.data);
        let feedbacksGiven = response.data.feedbackData && response.data.feedbackData.feedback ? response.data.feedbackData.feedback : [];
        // console.log('feedback length: ', feedbacksGiven.length);
        let numberFeedbacksGiven = feedbacksGiven.length;
        let currentId = numberFeedbacksGiven ? feedbacksGiven[numberFeedbacksGiven - 1]._id : undefined;
        let responseEmail = response.data.feedbackData ? response.data.feedbackData.email : undefined;
        this.setState({
          feedbackParams: {
            ...feedbackParams,
            email: responseEmail || feedbackParams.email
          },
          feedbacksGivenCount: numberFeedbacksGiven > 0,
          numberFeedbacksGiven: numberFeedbacksGiven,
          currentId: currentId
        })
      }).catch((err) => {
        console.log('error in feedback response: ', err);
      })
    } else {
      console.log('feedbackParams are empty: ', feedbackParams);
    }
    console.log('*** exiting compDidMnt (Feedback.js) ***');
  }

  render() {
    return (
      <div className='feedbackContainer'>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className='feedbackModal'
          open={this.state.open}
          onClose={this.handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
            sx: { backgroundColor: 'rgba(0, 0, 0, 0.25)' }
          }}
        >
          <Fade in={this.state.open}>
            <div className='feedbackModalFade'>
              <h2 id="transition-modal-title">Confirm your score {this.props.params && this.props.params.score ? this.renderScore(this.props.params.score) : null} </h2>
              <p className='modalButton' onClick={() => this.confirm(this.state)} id="transition-modal-description">confirm score</p>
            </div>
          </Fade>
        </Modal>
        <Grid container spacing={3} alignItems="stretch">
          <Grid size={{ xs: 12 }}>
            <h1 className='pageTitle'>Thanks for your feedback</h1>
            {this.state.numberFeedbacksGiven > 0 ? (
              <h3 className='feedbackSubTitle' style={{ fontSize: '28px', color: 'rgb(111, 111, 111)', fontWeight: '300', marginTop: '10px', marginBottom: '0px' }}>
                You have provided feedback {this.state.numberFeedbacksGiven} {this.state.numberFeedbacksGiven === 1 ? 'time' : 'times'}.
              </h3>
            ) : null}
          </Grid>
          <Grid size={{ xs: 12, md: 7 }}>
            <div className='feedbackCard'>
              <h1 style={{ position: 'relative', top: '-18px', marginBottom: '0px' }}>Final Step</h1>
              {this.state.feedbackParams.email === undefined ?
                <h3 className='feedbackSubTitle'>Thanks for giving us your feedback, we truly appreciate that.</h3> :

                this.state.feedbacksGivenCount === true && this.state.numberFeedbacksGiven < 2 ?
                    <h3 className='feedbackSubTitle'>We appreciate you filling out your first survey!</h3> : null

              }
              <div className='customeFeedbackHolder'>
                {this.state.feedbackParams.score ? this.feedbackScore(this.state.feedbackParams.score) : null}
              </div>
              {this.state.feedbackParams.score >= 9 ? (
                <div className='customeFeedbackHolder reviewBorderCard'>
                  <h3 className='feedbackSubTitle' style={{ fontSize: '38px', marginTop: '0px', marginBottom: '8px', color: 'rgb(173,0,51)' }}>
                    Help Others Find Us.
                  </h3>
                  <p style={{ marginTop: '0px', color: '#6f6f6f', fontSize: '18px', lineHeight: '25px' }}>
                    Takes under 1 minute
                    <br />
                    Include a sentence about our work - it helps
                  </p>
                  <a
                    href='https://g.page/r/Cc6MrKKRLt5eEAI/review'
                    target='_blank'
                    rel='noopener noreferrer'
                    className='modalButton reviewButton'
                    style={{ display: 'inline-block', textDecoration: 'none' }}
                  >
                    Write a Google Review
                  </a>
                </div>
              ) : null}
            </div>
          </Grid>
          <Grid size={{ xs: 12, md: 5 }}>
            <LandingContact
              landingForm={this.landingForm}
              emailAddress={this.props.params ? this.props.params.email : undefined}
              textFields={this.state.textFields}
            />
          </Grid>
        </Grid>
      </div>
    )
  }
}


export default Feedback;
